import { TextInput } from "components/DesignSystem/TextInput/TextInput";
import { Field, FieldProps } from "formik";

export const FilingEmailInput = ({ name, ...props }: { name: string }) => {
  return (
    <Field name={name} placeholder="Email" {...props}>
      {({ field, form: { touched, errors } }: FieldProps) => {
        return (
          <TextInput
            {...{ ...field, ...props }}
            type="email"
            placeholder="Email"
            customType={
              touched[field.name] || touched[field.name] === undefined
                ? "success"
                : "error"
            }
          />
        );
      }}
    </Field>
  );
};
